import StepsTipos from "./StepsTipo";
import CreditoService from "../../../api/CreditoService";
import DesafioService from "../../../api/DesafioService";
import TiposDeDocumentos from "./TiposDeDocumentos";
import ModalErrorAction from "../../main/ModalErrorAction";
import IdentidadService from "../../../api/AutorizarService"
import SeguroService from "../../../api/SegurosService";

export const validarStepAction = (actual, estado) => {
  return {
    type: StepsTipos.data.VALIDAR_STEP_ACTUAL,
    payload: { stepActual: actual, stepEstado: estado }
  };
};

export const obtenerSimuladorAction = (dato, trackId) => {
  return async dispatch => {
    try {
      if (dato.params.accion === "CUOTAS") {
        dispatch({
          type: StepsTipos.data.simulador.INICIO_SIMULADOR_CUOTA,
          payload: { enEjecucionAPISimularCuota: true }
        });
        const respuestaSimulador = await CreditoService.realizarSimulacion(dato, trackId);
        dispatch({
          type: StepsTipos.data.simulador.TERMINO_SIMULADOR_CUOTAS,
          payload: { datosCuotas: respuestaSimulador.data }
        });
      } else if (dato.params.accion === "SEGURO") {
        dispatch({
          type: StepsTipos.data.simulador.INICIO_SIMULADOR_SEGURO,
          payload: { enEjecucionAPISimularSeguro: true }
        });
        const respuestaSimulador = await CreditoService.realizarSimulacion(dato, trackId);
        dispatch({
          type: StepsTipos.data.simulador.TERMINO_SIMULADOR_SEGUROS,
          payload: { datosSeguro: respuestaSimulador.data }
        });
      } 
    } catch (error) {
      dispatch({ type: StepsTipos.data.ERROR, payload: error.request });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const volveraSimularAction = value => {
  return {
    type: StepsTipos.data.simulador.VOLVER_A_SIMULAR,
    payload: { estadoVolveraSimular: value }
  };
};

export const realizarFormalizacionCreditoAction = (trackId) => {
  return async dispatch => {
    try {
      dispatch({
        type: StepsTipos.data.INICIO_FORMALIZAR_CREDITO,
        payload: { enEjecucionFormalizacionAPI: true }
      });
      const respuestaServicio = await CreditoService.realizarFormalizacion(trackId);
      if(respuestaServicio.data && respuestaServicio.data.estadoFormalizacion && respuestaServicio.data.estadoFormalizacion===true){
        dispatch({
          type: StepsTipos.data.FORMALIZAR_CREDITO,
          payload: { formalizacion: respuestaServicio }
        });
      }else{
        dispatch({ type: StepsTipos.data.ERROR, payload: {errores: respuestaServicio.data} });
        dispatch(ModalErrorAction(true));
      }
      
    } catch (error) {
      dispatch({ type: StepsTipos.data.ERROR, payload: {errores : error} });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const obtenerDocumentoAction = (estado, tipoDocumento, trackId) => {
  return async dispatch => {
    try {
      if (tipoDocumento === TiposDeDocumentos.DoctoSolicitudProductoDeCredito_1
        || tipoDocumento === TiposDeDocumentos.DoctoSolicitudProductoDeCreditoWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_1,
          payload: { enEjecucionObtenerDocumentoAPI_1: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_1,
          payload: { DoctoSolicitudProductoDeCredito_1: respuestaServicio.data.documentos }
        });
      } else if (tipoDocumento === TiposDeDocumentos.DoctMandatoEspecialDeSuscripcion_2
        || tipoDocumento === TiposDeDocumentos.DoctMandatoEspecialDeSuscripcionWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_2,
          payload: { enEjecucionObtenerDocumentoAPI_2: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_2,
          payload: { DoctMandatoEspecialDeSuscripcion_2: respuestaServicio.data.documentos }
        });
      } else if (tipoDocumento === TiposDeDocumentos.DoctAnexoLiquidacionDeCredito_3
        || tipoDocumento === TiposDeDocumentos.DoctAnexoLiquidacionDeCreditoWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_3,
          payload: { enEjecucionObtenerDocumentoAPI_3: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_3,
          payload: { DoctAnexoLiquidacionDeCredito_3: respuestaServicio.data.documentos }
        });
      } else if (tipoDocumento === TiposDeDocumentos.DoctContratoDeCredito_4
        || tipoDocumento === TiposDeDocumentos.DoctContratoDeCreditoWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_4,
          payload: { enEjecucionObtenerDocumentoAPI_4: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_4,
          payload: { DoctContratoDeCredito_4: respuestaServicio.data.documentos }
        });
      } else if (tipoDocumento === TiposDeDocumentos.DoctHojaResumenDeCredito_5
        || tipoDocumento === TiposDeDocumentos.DoctHojaResumenDeCreditoWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_5,
          payload: { enEjecucionObtenerDocumentoAPI_5: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_5,
          payload: { DoctHojaResumenDeCredito_5: respuestaServicio.data.documentos }
        });
      } else if (tipoDocumento === TiposDeDocumentos.DoctAnexoServicioAtencionAlCliente_6
        || tipoDocumento === TiposDeDocumentos.DoctAnexoServicioAtencionAlClienteWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_6,
          payload: { enEjecucionObtenerDocumentoAPI_6: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_6,
          payload: { DoctAnexoServicioAtencionAlCliente_6: respuestaServicio.data.documentos }
        });
      } else if (tipoDocumento === TiposDeDocumentos.DoctSolIncorporacionYCertDeSeguros_7
        || tipoDocumento === TiposDeDocumentos.DoctSolIncorporacionYCertDeSegurosWeb) {
        dispatch({
          type: StepsTipos.data.documentos.INICIO_OBTENER_DOCUMENTOS_7,
          payload: { enEjecucionObtenerDocumentoAPI_7: true }
        });
        const respuestaServicio = await CreditoService.crearDocumento(estado, tipoDocumento, trackId);
        dispatch({
          type: StepsTipos.data.documentos.GUARDAR_DOCUMENTO_7,
          payload: { DoctSolIncorporacionYCertDeSeguros_7: respuestaServicio.data.documentos }
        });
      }
    } catch (error) {
      dispatch({ type: StepsTipos.data.documentos.ERROR, payload: error.request });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const obtenerDesafioCoordenadasAction = (trackId,desafioNuevo) => {
  return async dispatch => {
    try {
      dispatch({
        type: StepsTipos.data.coordenadas.INICIO_OBTENER_DESAFIO,
        payload: { enEjecucionAPIObtenerDesafio: true }
      });
      // MIGRACION
      dispatch({
        type: StepsTipos.data.autorizar.INICIO_AUTORIZACION,
        payload: { enEjecucionAutorizarAPI: true }
      });

      const respuesta = await DesafioService.obtenerCoordenadas(trackId,desafioNuevo);
      
      if (respuesta) {
        dispatch({
          type: StepsTipos.data.coordenadas.GUARDAR_COORDENADAS,
          payload: { coordenadas: respuesta }
        });
        // MIGRACION
        dispatch({
          type: StepsTipos.data.autorizar.OBTENER,
          payload: { 
            enEjecucionAutorizarAPI:false,
            datoRecibido: {coordenada:respuesta.data, sms:null} ,
            tipoAutorizacion:"coordenadas"
          }
        });
      } else {
        dispatch({
          type: StepsTipos.data.ERROR,
          payload: { mensaje: "No se ha podido obtener las coordenadas, intentelo nuevamente" }
        });
      }
    } catch (error) {
      dispatch({ type: StepsTipos.data.coordenadas.ERROR_COORDENADAS, payload: { statusError: 500 , mensajeError: error } });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const obtenerDesafioSmsAction = (trackId, idFlujo) => {
  return async dispatch => {
    try {
      dispatch({
        type: StepsTipos.data.autorizar.INICIO_AUTORIZACION,
        payload: { enEjecucionAutorizarAPI: true }
      });
      const respuesta = await DesafioService.obtenerSms(trackId,idFlujo);
      if (respuesta) {
        
        if(respuesta.data && respuesta.data.envioTercerFactor===true){
          dispatch({
            type: StepsTipos.data.autorizar.OBTENER,
            payload: { 
              enEjecucionAutorizarAPI:false,
              datoRecibido: {coordenada:null, sms:respuesta.data.envioTercerFactor} ,
              tipoAutorizacion:"sms"
            }
          });
        }else if(respuesta.error && respuesta.error.code){
          dispatch({
            type: StepsTipos.data.autorizar.ERROR,
            payload: { 
              enEjecucionAutorizarAPI:false,
              tipoAutorizacion:"sms",
              statusError: respuesta.error.code,
              mensajeError: respuesta.error.message
            }
          });
        }else{
          dispatch({
            type: StepsTipos.data.autorizar.ERROR,
            payload: { 
              enEjecucionAutorizarAPI:false,
              tipoAutorizacion:"sms",
              statusError:197,
              mensajeError: "No se ha podido obtener Sms, intentelo nuevamente" 
            }
          });
        }
        
      } else {
        dispatch({
          type: StepsTipos.data.autorizar.ERROR,
          payload: { 
            enEjecucionAutorizarAPI:false,
            tipoAutorizacion:"sms",
            statusError:500,
            mensaje: "No se ha podido obtener Sms" 
          }
        });
      }
    } catch (error) {
      dispatch({ 
        type: StepsTipos.data.autorizar.ERROR, 
        payload: { 
          statusError: 500 , 
          tipoAutorizacion:"sms",
          mensaje: error 
        } 
    });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const cursarCreditoAction = (emailAlternativo, enviarCorreoSecundario, enviarCorreoIbs, trackId) => {
  return async dispatch => {
    try {
      dispatch({ type: StepsTipos.data.cursar.INICIO_CURSAR_CREDITO, payload: { enEjecucionCursarCreditoAPI: true } });
      const respuestaServicio = await CreditoService.cursarCredito(emailAlternativo, enviarCorreoSecundario, enviarCorreoIbs,  trackId);
     
      if(respuestaServicio.error){
        dispatch({ type: StepsTipos.data.cursar.ERROR_CURSAR, payload: { statusError:  respuestaServicio.error.code , mensajeError:  respuestaServicio.error.message } });
      }else{
        dispatch({ type: StepsTipos.data.cursar.CURSAR_CREDITO, payload: { curse: respuestaServicio, statusError:null, mensajeError:null } });
      }
    } catch (error) {
      dispatch({ type: StepsTipos.data.cursar.ERROR_CURSAR, payload: { statusError: 500 , mensajeError:  error } });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const cursarSetAction  = () => {
  return async dispatch => {
      dispatch({ type: StepsTipos.data.cursar.SET });
  };
};

export const autorizarAction = (input, trackId, tipoAutorizacionIn) => {
  return async dispatch => {
    try {
      dispatch({ type: StepsTipos.data.autorizar.INICIO_AUTORIZACION, payload: { enEjecucionAutorizarAPI: true } });
      let respuestaServicio
      if(tipoAutorizacionIn==="coordenadas"){
        respuestaServicio = await IdentidadService.autorizarCordenada(input[0], input[1], input[2], trackId);
      }else if(tipoAutorizacionIn==="sms"){
        respuestaServicio = await IdentidadService.autorizarSms(input, trackId);
      }
      
      if(respuestaServicio.error){
        dispatch({ type: StepsTipos.data.autorizar.ERROR, payload: { statusError:  respuestaServicio.error.code , mensajeError:  respuestaServicio.error.message, enEjecucionAutorizarAPI: false } });
      }else{
        dispatch({ type: StepsTipos.data.autorizar.AUTORIZAR, payload: { autorizacion: respuestaServicio.data.esValido ? respuestaServicio.data.esValido:false, statusError:null, mensajeError:null, tipoAutorizacion: tipoAutorizacionIn, enEjecucionAutorizarAPI: false } });
      }
    } catch (error) {
      dispatch({ type: StepsTipos.data.autorizar.ERROR, payload: { statusError: 500 , mensajeError:  error, enEjecucionAutorizarAPI: false } });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const segurosAction = (trackId) => {
  return async dispatch => {
    try {
      
        dispatch({
          type: StepsTipos.data.seguros.BUSCA_SEGUROS,
          payload: { enEjecucionAPISimularCuota: true }
        });
        const listaSeguros = await SeguroService.buscar(trackId);
        dispatch({
          type: StepsTipos.data.seguros.OBTIENE_SEGUROS,
          payload: { lista: listaSeguros.data }
        });
    } catch (error) {
      dispatch({ type: StepsTipos.data.seguros.ERROR, payload: {errores : true} });
    }
  };
};


